// подключаем главную функцию с которой начинается выполнение
import {main} from './boot';

// конфигурационный файл, определяющий сетевой идентификатор игры
//import gameConfig from 'cfg/game-config.js';

// сгенерированная информация о версии игры
import versionInfo from './version';

// графическая метрика пользовательского интерфейса
import screenConfig from 'cfg/screen-config';
import resources from 'res/resources';

console.log(versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate);


// entry point
main(
    resources,
    //construct,
    // {
    //     gameNetworkId:gameConfig.gameNetworkId,
    //     gameName:versionInfo.name
    //     // bonusUserSelectionsPolicy
    // },
    //{},
    //uiConfig,
    screenConfig,
    versionInfo
);




// WEBPACK FOOTER //
// ./src/main.es6